// service.js
import { useApiHelper } from '../../utils/helper/apiHelper';

export const useDepositFundService = () => {
    const { post, loading } = useApiHelper();

    const getDepositWalletBalance = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const getBankByCurrency = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const doDeposit = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/RequestFundForProductwalletINR`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const getCurrencyValue = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const getTRC20Address = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_ADMIN_API_URL}/GenerateTRC20Address`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const getBEP20Address = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_ADMIN_API_URL}/GenerateBEP20USDTAddress`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const getFXSTTokenAddress = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_ADMIN_API_URL}/GenerateFXSTAddress`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const getDepositTransactions = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_API_URL}/ExecuteProcedure`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const SignUpDAPP = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_ADMIN_API_URL}/RegistrationDAPP`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    const TopUpDAPP = async (payload: any) => {
        try {
            return await post(`${import.meta.env.VITE_APP_ADMIN_API_URL}/TopUpDAPP`, payload);
        } catch (error) {
            console.error('Error fetching dashboard data:', error);
            throw error;
        }
    };
    
    return {
        getDepositWalletBalance,
        getBankByCurrency,
        getCurrencyValue,
        doDeposit,
        getTRC20Address,
        getBEP20Address,
        getFXSTTokenAddress,
        getDepositTransactions,
        loading,
        SignUpDAPP,
        TopUpDAPP
      
    };
    
};
